import React from 'react';

// Casa Libre content (skeleton) loaders — warm bone shimmer, no blur.
// Reusable across pages so every loading state looks consistent and polished.

export const Sk = ({ w = '100%', h = 12, r = 999, style }) => (
  <div className="cl-skel" style={{ width: w, height: h, borderRadius: r, ...style }} />
);

// A single placeholder card (matches .ui-card).
export const SkelCard = ({ lines = 3, avatar = false, children }) => (
  <div className="cl-skel-card">
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
      {avatar && <div className="cl-skel cl-skel-circle" style={{ width: 42, height: 42, flex: 'none' }} />}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Sk w="55%" h={13} />
        <Sk w="35%" h={9} />
      </div>
    </div>
    {children || Array.from({ length: lines }).map((_, i) => (
      <Sk key={i} w={`${90 - i * 12}%`} h={9} style={{ marginTop: 10 }} />
    ))}
  </div>
);

// A responsive grid of placeholder cards (Automations, AI Agents, Integrations).
export const SkelCardGrid = ({ count = 6, minWidth = 320, avatar = false, lines = 3 }) => (
  <div className="cl-skel-stagger" style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`, gap: 16 }}>
    {Array.from({ length: count }).map((_, i) => <SkelCard key={i} avatar={avatar} lines={lines} />)}
  </div>
);

// A stat-tile row (pages with a KPI strip).
export const SkelStats = ({ count = 4 }) => (
  <div className="cl-skel-stagger" style={{ display: 'grid', gridTemplateColumns: `repeat(auto-fit, minmax(180px, 1fr))`, gap: 12, marginBottom: 22 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="cl-skel-card" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px' }}>
        <div className="cl-skel cl-skel-circle" style={{ width: 38, height: 38, flex: 'none' }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}><Sk w="60%" h={16} /><Sk w="40%" h={9} /></div>
      </div>
    ))}
  </div>
);

// A table placeholder inside a card (Orders, Campaigns, Users, Tickets, Notifications).
export const SkelTable = ({ rows = 8, cols = 5 }) => (
  <div className="cl-skel-card" style={{ padding: 0, overflow: 'hidden' }}>
    <div style={{ background: '#FAF7F1', borderBottom: '1px solid #E7E1D6', padding: '11px 16px', display: 'flex', gap: 24 }}>
      {Array.from({ length: cols }).map((_, i) => <Sk key={i} w={i === 0 ? 120 : 70} h={9} />)}
    </div>
    <div className="cl-skel-stagger">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{ display: 'flex', alignItems: 'center', gap: 24, padding: '14px 16px', borderBottom: r === rows - 1 ? 'none' : '1px solid #F1ECE2' }}>
          {Array.from({ length: cols }).map((_, c) => (
            <Sk key={c} w={c === 0 ? 140 : `${60 - c * 4}px`} h={10} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

// An avatar-row list (chats, team).
export const SkelList = ({ rows = 7 }) => (
  <div className="cl-skel-stagger" style={{ display: 'flex', flexDirection: 'column' }}>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: i === rows - 1 ? 'none' : '1px solid #F1ECE2' }}>
        <div className="cl-skel cl-skel-circle" style={{ width: 44, height: 44, flex: 'none' }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}><Sk w="40%" h={11} /><Sk w="70%" h={8} /></div>
        <Sk w={48} h={9} />
      </div>
    ))}
  </div>
);

// A centered full-card loader with the shimmer, for smaller regions.
export const SkelBlock = ({ h = 200 }) => <div className="cl-skel" style={{ width: '100%', height: h, borderRadius: 12 }} />;

const Skeletons = { Sk, SkelCard, SkelCardGrid, SkelStats, SkelTable, SkelList, SkelBlock };
export default Skeletons;
